import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { pageTypes } from 'apps/analytics';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

import {
  getCatalogueLink,
} from 'apps/catalogue/links';
import DesktopCatalogueBreadcrumbs from 'apps/catalogue/components/breadcrumbs/DesktopCatalogueBreadcrumbs';
import DisplayOptions from 'apps/catalogue/components/DisplayOptions';
import EnforceProductsPageLocation from 'apps/meta/components/EnforceProductsPageLocation';
import ImpressionsPageType from 'apps/gtm/containers/ImpressionsPageType';
import MainFopContainer from 'apps/catalogue/containers/MainFopContainer';
import MobileCatalogueBreadcrumbs from 'apps/catalogue/components/breadcrumbs/MobileCatalogueBreadcrumbs';
import PageViewType from 'apps/analytics/components/PageViewType';
import ProductsPageFilterSidebar from 'apps/catalogue/components/sidebar/ProductsPageFilterSidebar';
import SubNavigation from 'apps/navigation/containers/SubNavigation';
import TotalProductNumber from 'apps/catalogue/components/TotalProductNumber';

import CouponsInfoSection from '../containers/CouponsInfoSection';
import CouponsEmptyState from './CouponsEmptyState';
import PageViewEvent from 'apps/analytics/containers/PageViewEvent';

export default class CouponsPage extends Component {
  static propTypes = {
    basePath: PropTypes.string.isRequired,
    betaFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
    openMobileRefineBy: PropTypes.func.isRequired,
    productsPage: PropTypes.shape({
      pageParameters: PropTypes.object.isRequired,
      generalPageInfo: PropTypes.object,
      outOfStockStatistics: PropTypes.array,
      mainFopCollection: PropTypes.object.isRequired,
      navWithFilters: PropTypes.shape({
        filters: PropTypes.array,
      }).isRequired,
    }).isRequired,
    routeString: PropTypes.string.isRequired,
  };

  handleRefineByClick = () => {
    const { openMobileRefineBy, routeString } = this.props;

    openMobileRefineBy(routeString);
  };

  generateMainFopList() {
    const {
      betaFeatures,
      productsPage: {
        pageParameters, generalPageInfo, outOfStockStatistics, mainFopCollection,
      },
      routeString,
    } = this.props;

    return (
      <MainFopContainer
        betaFeatures={betaFeatures}
        fopCollection={mainFopCollection}
        generalPageInfo={generalPageInfo}
        gtmPageType={gtmPageTypes.Coupons}
        outOfStockStatistics={outOfStockStatistics}
        pageParameters={pageParameters}
        routeString={routeString}
      />
    );
  }

  render() {
    const { basePath, betaFeatures, productsPage = {}, routeString } = this.props;
    const { generalPageInfo, navWithFilters, pageParameters } = productsPage;

    return (
      <div>
        <PageViewEvent eventData={{ pageType: pageTypes.COUPONS }} />
        <PageViewType pageType={pageTypes.COUPONS} />
        <ImpressionsPageType pageType={gtmPageTypes.Coupons} />
        { !generalPageInfo.itemsCount
          ? <CouponsEmptyState />
          : (
            <Fragment>
              <EnforceProductsPageLocation
                href={getCatalogueLink(pageParameters, basePath, true)}
                pageParameters={pageParameters}
                routeString={routeString}
              />
              <div className="sidebar">
                <SubNavigation
                  linksRoot="/coupons"
                  productsPage={productsPage}
                  forceHidePromo
                />
                <ProductsPageFilterSidebar
                  basePath={basePath}
                  filters={navWithFilters.filters}
                  pageParameters={pageParameters}
                  routeString={routeString}
                />
              </div>
              <div className="main-column">
                <DesktopCatalogueBreadcrumbs
                  baseName="Coupons"
                  basePath="/coupons"
                  pageParameters={pageParameters}
                />
                <div className="catHeaderBar">
                  <MobileCatalogueBreadcrumbs
                    baseName="Coupons"
                    categories={pageParameters.category}
                    cluster={pageParameters.cluster}
                    filters={pageParameters.filters}
                    itemsCount={generalPageInfo.itemsCount || 0}
                  />
                </div>
                <CouponsInfoSection />
                <div className="catHeaderBar">
                  <div className="desktop-product-count show-for-xlarge">
                    <TotalProductNumber itemsCount={generalPageInfo.itemsCount || 0} />
                  </div>
                  <DisplayOptions
                    pageParameters={pageParameters}
                    betaFeatures={betaFeatures}
                    displaySort={false}
                    onRefineByClick={this.handleRefineByClick}
                  />
                </div>
                {this.generateMainFopList()}
              </div>
            </Fragment>
          )}
      </div>
    );
  }
}
